import {Pagination as AntPagination} from 'antd'
import styled from 'styled-components'

const Wrapper = styled.div`
  & .ant-pagination-item {
    background-color: transparent;
  }
`

export const Pagination = (props:any) => (
  <Wrapper>
    <AntPagination {...props} />
  </Wrapper>
)